import React from 'react';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({ 
  label,
  error, 
  className = '', 
  ...props 
}) => {
  const checkboxClasses = 'rounded border-gray-300 text-primary-600 focus:ring-primary-500';
  const errorClasses = error ? 'border-red-500' : '';
  
  return (
    <label className={`flex items-center ${className}`}>
      <input
        type="checkbox"
        className={`${checkboxClasses} ${errorClasses}`}
        {...props}
      />
      <span className="mr-2 text-sm text-gray-700">{label}</span>
    </label>
  );
};

export default Checkbox; 